<template>
<e-chart ref="chart" />
</template>

<script>
import BaseFactorChart from './BaseFactorChart'
import EChart from '../../Charts/ECharts'

export default {
  name: 'MeteorologicalChart',
  components: {EChart},
  extends: BaseFactorChart,
  computed: {
    filterFactors () {
      return this.factorGroup.children.filter(factor => factor.rootFactorId !== 'METEOROLOGICAL:WIND_DIR')
    }
  },
  methods: {
    setSeries (chartOpt, unitMap) {
      let {data, unitProp} = this
      let series = []
      let factors = this.factorGroup.children
      let factorMap = factors.reduce((map, factor) => {
        map[factor.id] = factor
        return map
      }, {})

      this.buildWindSpeedDirection(factors, factorMap, unitMap, unitProp, data, series)
      this.buildHumidity(factors, factorMap, unitMap, unitProp, data, series)
      this.buildOtherFactors(factors, factorMap, unitMap, unitProp, data, series)
      this.buildTooltipFormatter(chartOpt)

      chartOpt.series = series
    },
    buildWindSpeedDirection (factors, factorMap, unitMap, unitProp, data, series) {
      let windSpeed = factors.find(factor => /^METEOROLOGICAL:WIND_SPEED/.test(factor.rootFactorId))
      let windDirection = factors.find(factor => /^METEOROLOGICAL:WIND_DIR/.test(factor.rootFactorId))

      if (windSpeed && windDirection) {
        let windSpeedId = windSpeed.id
        let windDirectionId = windDirection.id

        delete factorMap[windSpeedId]
        delete factorMap[windDirectionId]

        series.push({
          id: windSpeedId,
          name: '风速风向',
          type: 'line',
          symbol: `image://data:image/svg+xml;base64,${btoa(`<svg viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-50.000000, -60.000000)" fill-rule="nonzero" fill="#fc8452"><polygon transform="translate(58.000000, 68.000000) scale(1, -1) rotate(90.000000) translate(-58.000000, -68.000000) " points="50 73 55.3076923 68 50 63 66 68"></polygon></g></g></svg>`)}`,
          yAxisIndex: unitMap[windSpeed[unitProp]],
          color: '#fc8452',
          data: data.map(data => {
            let windSpeedVal = data[windSpeedId]
            let windDirectionVal = data[windDirectionId]

            return {
              value: Number.isFinite(windSpeedVal) ? windSpeedVal : NaN,
              symbolSize: 20,
              symbolRotate: Number.isFinite(windDirectionVal) ? (180 - windDirectionVal) : 0
            }
          })
        })
      }
    },
    buildHumidity (factors, factorMap, unitMap, unitProp, data, series) {
      let humidity = factors.find(factor => /^METEOROLOGICAL:HUMIDITY/.test(factor.rootFactorId))

      if (humidity) {
        let humidityId = humidity.id
        delete factorMap[humidityId]

        series.push({
          id: humidityId,
          name: humidity.name,
          type: 'bar',
          yAxisIndex: unitMap[humidity[unitProp]],
          color: '#3ba272',
          data: data.map(data => {
            let value = data[humidityId]
            return Number.isFinite(value) ? value : NaN
          })
        })
      }
    },
    buildOtherFactors (factors, factorMap, unitMap, unitProp, data, series) {
      Object.values(factorMap).forEach(factor => {
        let factorId = factor.id

        series.push({
          id: factorId,
          name: factor.name,
          type: 'line',
          yAxisIndex: unitMap[factor[unitProp]],
          symbol: 'none',
          data: data.map(data => {
            let value = data[factorId]
            return Number.isFinite(value) ? value : NaN
          })
        })
      })
    },
    buildTooltipFormatter (chartOpt) {
      chartOpt.tooltip.formatter = params => (params[0] ? `<div>${params[0].name}</div>` : '') + params.map(({marker, seriesName, data}) => `<div style="margin-top:5px;">${marker}<span>${seriesName}</span><span style="float:right;padding-left:1em;">${seriesName === '风速风向' ? Number.isFinite(data.value) ? `${data.value}${Number.isFinite(data.symbolRotate) ? `(${(180 - data.symbolRotate).toFixed(2)})` : ''}` : '--' : (Number.isFinite(data) ? data : '--')}</span></div>`).join('')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/FactorCharts/MeteorologicalChart.vue